/**
 * Sidebar entry on/off switch (user decision 2026-09-28): a single named eCode may hide any
 * sidebar entry from everyone else and block its route, while still seeing and opening it
 * themself (badged) to test before flipping it back on.
 *
 * Stored as one app.AppSetting row (no schema change) rather than its own table: this is a
 * short list of path strings that changes rarely, the exact shape monet.editorECodes and
 * nav.disabled's own name already use for the same kind of on/off list.
 */
/** The only eCode allowed to flip sidebar entries on/off (user decision 2026-09-28). */
export const NAV_TOGGLE_ADMIN_ECODES = ['SPN004'];
/** app.AppSetting key holding the JSON array of disabled sidebar paths. */
export const NAV_DISABLED_SETTING_KEY = 'nav.disabled';
/**
 * Paths that can never be disabled: the dashboard (the one page every signed-in caller must be
 * able to reach) and /admin (it hosts the switch itself — disabling it would strand the one
 * eCode who could turn it back on).
 */
export const NAV_TOGGLE_LOCKED_PATHS = ['/', '/admin'];
//# sourceMappingURL=nav-toggles.contract.js.map